import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Heading, Text, VStack } from '@bonusly/design-system';

import { Bizy } from '../../../components/bizy';

export const BizyHistoryEmptyState: FC = () => {
	const { t } = useTranslation('bizy_history');

	return (
		<VStack spacing={6} py={16} align="center">
			<Bizy state="curious" size="lg" />
			<VStack spacing={2} align="center" maxW="md">
				<Heading size="md" color="text.default" textAlign="center">
					{t('empty_state.title')}
				</Heading>
				<Text fontSize="sm" color="text.soft" textAlign="center">
					{t('empty_state.description')}
				</Text>
			</VStack>
		</VStack>
	);
};
